import Link from '../../views/Login';
import { connect } from 'react-redux';
import { actions } from '../../../state/auth';
//import { request } from 'http';
import { push } from 'connected-react-router';
import {config} from "../../../utility/swaggerClient";

const mapStateToProps = (state, ownProps) => ({
    authenticated: state.shift.auth.authenticated,
    locale: ownProps.match.params.locale,
    status: state.shift.status
  });

const mapDispatchToProps = (dispatch, ownProps) => {
  const { locale } = ownProps.match.params;

  return {
    login: (username, password, ipAddress,deviceInfo) => {
      dispatch(actions.login(username, password, ipAddress,deviceInfo)).then(res => {
        console.log(res);
        const jwtToken = res.value.data.token;
        if (jwtToken !== null) {
          sessionStorage.setItem('jwt', jwtToken);
          //this.setState({ isAuthenticated: true });
        }
      });
    },

    clearData: () => {
      if (window.confirm('Would you like to clear all Shift local storage?')) {
        localStorage.clear();
        sessionStorage.clear();
        window.location.reload();
      }
    },

    gotoPasswordforgot: ()=>{
      dispatch(push(`/${locale}/passwordforgot`));
    },

    gotoAWS: ()=>{
      window.open(config.unregister_url);
      console.log("go to AWS");
    },

    resetPopError: ()=>{
      dispatch(actions.resetPopError())
    }
  };
};

const Login = connect(
  mapStateToProps,
  mapDispatchToProps
)(Link);

export default Login;



// WEBPACK FOOTER //
// ./src/components/container/Login/index.js